/**
 * Special Zendesk string for interactive displays on search
 * @type {string}
 */
export const ZENDESK_TABLE = "table";
export const ZENDESK_BUTTON = "button";
